<template>
<div>
  <v-card elevation="0">
      <v-card-text>
        <v-card outlined>
          <v-simple-table fixed-header height="350px" id="tableXls" ref="tableXls">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Date</th>
                  <th class="text-left">Count</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(doc, idx) in docs" :key="idx">
                  <td>{{doc._id}}</td>
                  <td>{{doc.count}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn class=" white--text" color="green" depressed @click="export2xls">Export to XLS</v-btn>
        <v-spacer></v-spacer>
        <span class="compact-form">Jumlah Hari</span>
        <v-text-field v-model="days" outlined dense hide-details="auto" class="compact-form" style="max-width:100px"></v-text-field>
        <v-btn class="white--text" color="blue" depressed @click="initialize">Submit</v-btn>
      </v-card-actions>
  </v-card>
</div>
</template>

<script>
import moment from 'moment'
import { utils, writeFileXLSX } from 'xlsx';

  // const short = require('short-uuid');
  export default {
    data: () => ({
      dialog: false,
      headers: [
        { text: 'Periode', value: 'period' },
        { text: 'Agung', value: 'agung' },
        { text: 'Ridho', value: 'ridho' },
        { text: 'Vindi', value: 'vindi' },
      ],
      docs: [],
      days: 30
    }),

    computed: {

    },

    watch: {

    },

    created () {
      this.initialize()
    },
    filters: {
        moment: function (date) {
            if (!date || date=='undefined') return ''
            return moment(date).format('D-MMM-YYYY HH:mm:ss');
        }
    },

    methods: {
      async initialize () {
        const payload = {
          days: this.days
        }
        this.docs = await this.$store.dispatch('reports/getPostObjs', {purl:'reports/getdau', pload:payload})
        console.log(this.docs)
      },

      export2xls() {
        const tableDom = document.getElementById('tableXls').childNodes[0].childNodes[0]
        console.log(tableDom)
          const wb = utils.table_to_book(tableDom)
          writeFileXLSX(wb, "rawdata-adventuraja.xlsx")

      },
      
    },
  }
</script>